import cloneDeep from 'lodash/cloneDeep';

export const state = {
  selectedCampaign: null,
  campaignRecipients: [],
  overriddenCampaignEmailTemplate: null,
  overriddenCampaignSmsTemplate: null,
  recipientCount: 0,
};

export const getters = {};

export const mutations = {
  setSelectedCampaign(state, value) {
    state.selectedCampaign = value;
  },
  setAddCampaignRecipient(state, value) {
    const { type, prospect } = value;
    const campaignRecipientsClone = cloneDeep(state.campaignRecipients);
    if (type) {
      prospect.selectedCommsOpt = type;
    }
    campaignRecipientsClone.push(prospect);
    state.campaignRecipients = campaignRecipientsClone;
    state.recipientCount = campaignRecipientsClone.length;
  },
  setRemoveCampaignRecipient(state, value) {
    const campaignRecipientsClone = cloneDeep(state.campaignRecipients);
    const i = campaignRecipientsClone.findIndex(
      (prospect) => prospect._id === value._id
    );
    if (i >= 0) {
      campaignRecipientsClone.splice(i, 1);
      state.campaignRecipients = campaignRecipientsClone;
      state.recipientCount = campaignRecipientsClone.length;
    }
  },
  setRecipientSelectedCommsOpt(state, value) {
    const campaignRecipientsClone = cloneDeep(state.campaignRecipients);
    const i = campaignRecipientsClone?.findIndex(
      (prospect) => prospect._id === value.prospect._id
    );
    value.type
      ? (campaignRecipientsClone[i].selectedCommsOpt = value.type)
      : delete campaignRecipientsClone[i].selectedCommsOpt;
    state.campaignRecipients = campaignRecipientsClone;
  },
  setUpdateRecipientMsg(state, value) {
    const { msg } = value;
    const campaignRecipientsClone = cloneDeep(state.campaignRecipients);
    const i = campaignRecipientsClone?.findIndex(
      (prospect) => prospect._id === value.prospect._id
    );
    campaignRecipientsClone[i].message = msg;
    state.campaignRecipients = campaignRecipientsClone;
  },
  setUpdateRecipientCount(state, value) {
    state.recipientCount = value;
  },
  setClearCampaignRecipients(state) {
    state.campaignRecipients = [];
  },
};

export const actions = {};
